export const LEAD_SENT_KEY = 'webchat_lead_sent'

// One chat_lead per browser session: in-memory ref guards this mount,
// sessionStorage dedupes across remounts/tabs within the session. Deliberately
// not localStorage — a return visit on another day is a legitimate new lead,
// consistent with GA4 session scoping.
export function markChatLeadOnce(fired: { current: boolean }): boolean {
  if (fired.current) return false
  let alreadySent = false
  try {
    alreadySent = !!sessionStorage.getItem(LEAD_SENT_KEY)
  } catch {
    /* ignore */
  }
  if (alreadySent) return false
  fired.current = true
  try {
    sessionStorage.setItem(LEAD_SENT_KEY, '1')
  } catch {
    /* ignore */
  }
  return true
}
